<!-- Banner -->
<pc-image-banner 
    [imgUrl]="project?.bannerImgUrl || ''" [simpleImage]="true"
>
</pc-image-banner>

<!-- Details -->
<div class="site-gutter white-gutter">
    <div class="project-detail-container">
        <div class="wrapper">
            <div class="detail-copy">
                <h1>{{project?.title}}</h1>
                @for (paragraph of project?.projectDescription; track $index) {
                    <p>{{paragraph}}</p>
                }
            </div>
            <pc-key-metrics
                [projectSize]="project?.projectSize || ''"
                [servicesList]="project?.servicesList || []"
                [clientName]="project?.clientName || ''"
                [locationName]="project?.locationName || ''"
                [sector]="project?.sector || ''"
                [architectName]="project?.architectName || ''"
                [contractorName]="project?.contractorName || ''"
            >
            </pc-key-metrics>
        </div>
    </div>
</div>

<!-- Gallery -->
<div class="project-image-gallery">
    <div class="site-gutter white-gutter">
        <div class="wrapper">
            <h3>Project Highlights</h3>
            <pc-photo-gallery [imageList]="project?.galleryImages"></pc-photo-gallery>
        </div>
    </div>
</div>

<!-- Seatbelt -->
<pc-seat-belt
    [copy]="'Ready to experience the PC Haines difference? Submit a bid request today.'"
    [buttonText]="'Submit a Request'"
    [buttonUrl]="'/contact-us'"
    [urlFragment]="'bid-request'"
></pc-seat-belt>

<!-- Related -->
 @if (false) {
    <!-- Hiding until more project data is available -->
    <div class="related-projects-container">
        <div class="site-gutter white-gutter">
            <div class="wrapper">
                <h3>Related Projects</h3>
                <div class="project-list">
                    @for (project of project?.projectList; track $index) {
                        <pc-project-card
                        [imageUrl]="project.imageUrl"
                        [title]="project.title"
                        [divisions]="project.divisions"
                        [projectUrl]="project.projectUrl"
                        [projectDate]="project.projectDate"
                        ></pc-project-card>
                    }
                </div>
            </div>
        </div>
    </div>
}